<template>
	<div class="search-view statistical-page" ref="container">
		<div class="title"> <div>搜索条件</div> </div>
		
		<div class="date-label" v-if="dateFilter">
			<div class="date-item" :class="date == 'all' ? 'on' : ''"  @click="setTime('all')">全部</div>
			<div class="date-item" :class="date == 'today' ? 'on' : ''"  @click="setTime('today')">今天</div>
			<div class="date-item" :class="date == 'yesterday' ? 'on' : ''"  @click="setTime('yesterday')">昨天</div>
			<div class="date-item" :class="date == 'lately7' ? 'on' : ''"  @click="setTime('lately7')">最近7天</div>
			<div class="date-item" :class="date == 'month' ? 'on' : ''"  @click="setTime('month')">本月</div>
			<div class="date-item" :class="date == 'year' ? 'on' : ''"  @click="setTime('year')">本年</div>
			<div class="date-item" :class="date == 'date' ? 'on' : ''"  @click="showDateRange">{{rangeDate || '自定义'}}</div>
		</div>
		
		<div class="input-label" v-for="(item, index) in label" :key="index">
			<div class="label-name">{{item.title}}</div>
			<div class="label-content" v-if="item.type != 'select'"><input type="text" v-model="filter[item.field]"></div>
			<div v-if="item.type == 'select'" class="label-radio-content">
				<RadioGroup v-model="priceType" direction="horizontal" @change="radioChange($event, item.field)">
				  <Radio name="" checked-color="#F5A100">全部</Radio>
				  <Radio name="2" checked-color="#F5A100">洗宠收益</Radio>
				  <Radio name="8" checked-color="#F5A100">商场分佣</Radio>
				</RadioGroup>
			</div>
		</div>
		
		<div class="btn-view">
			<div class="btn-search" @click="search">搜索</div>
		</div>
		
		
		<div class="calendar-wrapper" :class="current === true ? 'on' : ''">
		  <div class="calendar">
				<div class="calendar-top">
					<div class="btn cancel" @click="closeDateRange">取消</div>
					<div class="btn confirm" @click="confirmDate">确认</div>
				</div>
		    <Calendar
		      :clean="clean"
		      ref="calendar"
		      :range="isrange"
					@select="select"
		      :value="value"
		      responsive
		      :begin="[2000, 5, 20]"
		      :end="[2049, 5, 20]"
		    />
		  </div>
		</div>
		<div
		  class="mask"
		  @touchmove.prevent
		  v-show="current === true"
		  @click="closeDateRange"
		></div>
		
	</div>
</template>

<script>
import {RadioGroup, Radio} from 'vant';
import Calendar from "mpvue-calendar";
import "mpvue-calendar/src/browser-style.css";
const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;
const day = new Date().getDate();
export default {
  name: "Search",
	components: {
	  Calendar,
		RadioGroup, Radio
	},
  props: {
		options: {
			type: Object,
			default: {},
		},
		dateFilter : {
			type: Boolean,
			default : false
		},
    label: {
      type: Array,
      default: []
    }
  },
	data: function() {
	  return {
			filter : {},
			priceType : '',
			date : 'all',
			current : false,
			clean: true, //简洁模式
			isrange: true,
			monFirst: true,
			value: [[year, month, day - 1], [year, month, day]],
			renderValues: [[year, month, day - 1].join('-'), [year, month, day].join('-')],
			rangeDate : '',
		}
	},
	watch: {
	  options(newVal, oldVal) {
			if (newVal.date) this.date = newVal.date
			this.priceType = newVal.priceType
	  }
	},
	mounted() {
		console.log('search_mounted')
		if (this.options && this.options.date) this.date = this.options.date
		if (this.options && this.options.priceType) this.priceType = this.options.priceType
	},
	created() {
		console.log('search_created')
	},
	methods: {
		radioChange(val, field) {
			this.filter[field] = val;
		},
		reSet(filter) {
			this.filter = filter || {}
		},
		search() {
			this.$emit('search', this.filter)
		},
		confirmDate() {
			this.date = 'date'
			this.current = false;
			this.rangeDate = this.renderValues.join(" - ");
			this.filter.date = this.rangeDate;
		},
		showDateRange: function() {
		  this.current = true;
		},
		closeDateRange: function() {
		  this.current = false;
		},
		setTime(type) {
			this.date = type;
			this.filter.date = type;
			this.rangeDate = "自定义"
		},
		handelRenderValues(date) {
			if (!date) return this.renderValues = [];
		  const values = [];
		  date.forEach((v, i) => {
		    values.push(v.join("-"));
		  });
		  this.renderValues = values
		},
		select(val1, val2) {
			if (val1 && val2) {
				this.handelRenderValues([val1, val2]);
			} else if (val1) {
				this.handelRenderValues([val1]);
			} else {
				this.handelRenderValues(null);
			}
		}
	}
};
</script>
<style lang="scss">
	.search-view {
		width: 100%;
		background: #FFFFFF;
		border-radius: .2rem;
		padding: .3rem;
		
		.title {
			font-weight: 600;
			font-size: .36rem;
			color: #000000;
		}
		
		.date-label {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-top: 0.26rem;
			
			.date-item {
				width: 1.75rem;
				height: 0.68rem;
				padding: 0.12rem 0rem;
				margin-bottom: 0.2rem;
				font-weight: 400;
				font-size: .28rem;
				color: rgba(102,102,102,0.6);
				line-height: .4rem;
				text-align: center;
				border-radius: .08rem;
				border: .02rem solid rgba(153,153,153,0.3);
				
				&.on{
					border-color: #F5A100;
					background: #F5A100;
					color: #fff;
					font-weight: bold;
				}
			
				&:last-child {
					width: 100%;
				}
			}
		}
		
		.input-label {
			margin-top: .2rem;
			.label-name {
				font-weight: 400;
				font-size: .28rem;
				color: #000000;
			}
			.label-content {
				padding: 0.24rem 0.4rem;
				margin-top: .2rem;
				height: .88rem;
				background: #F8F8F8;
				border-radius: .08rem;
				
				input { width: 100%;}
			}
			.label-radio-content {
				padding-top: 0.3rem;
			}
		}
		
		.btn-view {
			margin-top: 0.4rem;
			.btn-search {
				color: #FFFFFF;
				text-align: center;
				line-height: 1rem;
				font-size: .34rem;
				height: 1rem;
				background: #F5A100;
				border-radius: .5rem;
			}
		}
		
		
	}
	
	.calendar-wrapper {
	  position: fixed;
	  bottom: 0;
	  left: 0;
	  width: 100%;
	  z-index: 777;
	  transform: translate3d(0, 100%, 0);
	  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
	}
	
	.calendar-top {
		position: relative;
		background: #fff;
		display: flex;
		height: 1rem;
		align-items: center;
		justify-content: space-between;
		
		.btn {
			width: 100px;
			height: 1rem;
			text-align: center;
			line-height: 1rem;
		}
		.cancel {
			color: #9E9E9E;
		}
		.confirm {
			font-weight: bolder;
		}
		
	}
	
	.calendar-wrapper.on {
	  transform: translate3d(0, 0, 0);
	}
	.statistical-page .wrapper .increase {
	  font-size: 0.26rem;
	}
	.statistical-page .wrapper .increase .iconfont {
	  margin-left: 0;
	}
</style>
